var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12", grow: "", shrink: "" } },
    [
      _c(
        "w-row",
        { attrs: { center: "" } },
        [
          _vm._t("default"),
          _c("w-spacer"),
          _c(
            "div",
            [
              _c(
                "w-col",
                [
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.add()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: !_vm.selectedItem },
                          on: {
                            click: function ($event) {
                              return _vm.edit()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "pen" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: _vm.selectedRows.length == 0 },
                          on: {
                            click: function ($event) {
                              return _vm.remove()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-row",
        { attrs: { grow: "", shrink: "" } },
        [
          _c(
            "w-col",
            [
              _c("w-data-table", {
                style: { flexGrow: 1 },
                attrs: {
                  columns: _vm.columns,
                  items: _vm.scripts,
                  "selected-items": _vm.selectedRows,
                  compare: _vm.compare,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }